import axios from "axios";
import * as actionTypes from "./types";

export const setAll = files => {
  return {
    type: actionTypes.ALL,
    payload: files
  };
};

export const getAll = actionType => {
  return dispatch => {
    axios.get("/api/files").then(res => {
      dispatch(setAll(res.data));
      switch (actionType) {
        case actionTypes.ALL_SPECIFICATIONS:
          dispatch(setAllSpecifications());
          break;
        case actionTypes.PUBLICATIONS:
          dispatch(setPublications());
          break;
        case actionTypes.LAST_UPDATES:
          dispatch(setLastUpdates());
          break;
        default:
          break;
      }
    });
  };
};

export const getAllSpecificatios = () => {
  return (dispatch, getState) => {
    if (getState().files.allFiles.length > 0) {
      dispatch(setAllSpecifications());
    } else {
      dispatch(getAll(actionTypes.ALL_SPECIFICATIONS));
    }
  };
};

// export const getLastSpecifications = () => {
//   return (dispatch, getState) => {
//     if (getState().files.allSpecifications.length == 0) {
//       dispatch(getAllSpecificatios());
//       dispatch(setLastSpecifications());
//     }
//   };
// };

export const sort = (listName, descending) => {
  let actionType = "";
  switch (listName) {
    case "allSpecifications":
      actionType = actionTypes.ALL_SPECIFICATIONS_REVERSE;
      break;
    case "publications":
      actionType = actionTypes.PUBLICATIONS_REVERSE;
      break;
    case "lastUpdates":
      actionType = actionTypes.LAST_UPDATES_REVERSE;
      break;
  }
  return {
    type: actionType,
    payload: descending
  };
};

export const getPublications = () => {
  return (dispatch, getState) => {
    if (getState().files.allFiles.length > 0) {
      dispatch(setPublications());
    } else {
      dispatch(getAll(actionTypes.PUBLICATIONS));
    }
  };
};

export const getLastUpdates = () => {
  return (dispatch, getState) => {
    if (getState().files.allFiles.length > 0) {
      dispatch(setLastUpdates());
    } else {
      dispatch(getAll(actionTypes.LAST_UPDATES));
    }
  };
};

export const setAllSpecifications = () => {
  return {
    type: actionTypes.ALL_SPECIFICATIONS
  };
};

// export const setLastSpecifications = () => {
//   return {
//     type: actionTypes.LAST_SPECIFICATIONS
//   };
// };

export const setPublications = () => {
  return {
    type: actionTypes.PUBLICATIONS
  };
};

export const setLastUpdates = () => {
  return {
    type: actionTypes.LAST_UPDATES
  };
};
